<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="">
    <!-- <div class="header">
      <div>
        <h2 class="title">
          <div> -->
            <!-- <span *ngIf="baseFormGroup.get('ID').value<=0">Nova stavka</span>
            <span *ngIf="baseFormGroup.dirty" style="color:steelblue">*</span>
            <span *ngIf="editMode" class="fa fa-fw fa-pencil item-icon"></span> -->
          <!-- </div>
        </h2>
      </div>
    </div> -->

    <!-- <div> -->
      <div class="row mt-2">
        <div class="col-xl-3 col-md-6">
          <div class="form-group row">
            <!-- <label for="cmbArtikal" class="col-form-label col-md-3">
              <span translate="PRODUCT.SINGULAR"></span>
            </label> -->
            <div class="col-md-12">
              <!-- <yt-fw-dropdown
                id="ddlRoba" 
                [ModelName]="'roba'" 
                [GetName]="'get'" 
                [ModelProperty]="'Naziv,UnitOfMeasure.Symbol'"
                formControlName="RobaID"
                [Type]="ID"
                [Label]="'DOKUMENTSTAVKE.ROBA.SINGULAR'"
                #autofocus>
              </yt-fw-dropdown> -->
              <yt-dropdown-picklist
                [ModelName]="'roba'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv,UnitOfMeasure.Symbol'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="RobaID"
                [Label]="'DOKUMENTSTAVKE.ROBA.SINGULAR'"
              >                
              </yt-dropdown-picklist>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="form-group row">
            <!-- <label for="cmbMagacin" class="col-form-label col-md-3">
              <span translate="WAREHOUSE.SINGULAR"></span>
            </label> -->
            <div class="col-md-12">
              <!-- <yt-fw-dropdown
                [ModelName]="'magacin'" 
                [GetName]="'get'" 
                [ModelProperty]="'Naziv'"
                formControlName="MagacinID"
                [Type]="ID"
                [Label]="'DOKUMENTSTAVKE.MAGACIN.SINGULAR'">
              </yt-fw-dropdown> -->
              <yt-dropdown-picklist
                [ModelName]="'magacin'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="MagacinID"
                [Label]="'DOKUMENTSTAVKE.MAGACIN.SINGULAR,'"
              >
              </yt-dropdown-picklist>         
            </div>
          </div>
        </div>
      <!-- </div> -->


      <!-- ng-if="parameters.getParameters[0].value==1"  -->


      <!-- <div class="row"> -->
        <div class="col-xl-3 col-md-6">
          <div class="form-group row">
            <!-- <label for="txtSerija" class="col-form-label col-md-3">
              <span translate="SERIES.SINGULAR">Serija</span>
            </label> -->
            <div class="col-md-12">
              <!-- <input 
                type="text" 
                id="txtSerija" 
                name="txtSerija"
                formControlName="Serija" 
                class="form-control"
                placeholder="DOKUMENTSTAVKE.SERIJA.SINGULAR"> -->
                <yt-input
                  [Type]="'text'"
                  [Label]="'DOKUMENTSTAVKE.SERIJA.SINGULAR'"
                  formControlName="Serija">
                </yt-input>
              <!-- <div class="error" ng-show="savingItem && isInvalid(selectedItem.Serija)">Serija je obavezan podatak!</div> -->
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="form-group row">
            <!-- <label for="txtDatumIsteka" class="col-form-label col-md-3">
              <span translate="DATE.EXPIRY.SINGULAR">Datum isteka</span>
            </label> -->
            <div class="col-md-12">
              <yt-fw-date-picker-popup
                name="txtDatumIsteka" 
                formControlName="DatumIsteka"
                [Label]="'DATE.EXPIRY.SINGULAR'">
              </yt-fw-date-picker-popup>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 col-md-6">
          <div class="form-group row">
            <!-- <label for="txtKolicina" class="control-label col-md-6">
              <span translate="DOCUMENT.QUANTITY.SINGULAR">Količina</span>
            </label> -->
            <div class="col-md-12">
              <!-- <input 
                  type="number"
                  id="txtKolicina"
                  name="txtkolicina"
                  formControlName="Kolicina"
                  class="form-control text-right"
                  placeholder="DOKUMENTSTAVKE.KOLICINA.SINGUALR"> -->
                <yt-input
                  [Type]="'text'"
                  [Label]="'DOKUMENTSTAVKE.KOLICINA.SINGULAR'"
                  formControlName="Kolicina">
                </yt-input>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
            <!-- <div class="col-md-3" *ngIf="isVisible('txtNabavnaCena')"> -->
          <div class="form-group row">
            <!-- <label for="txtDobavljacCena" class="control-label col-md-6">Nabavna cena</label> -->
            <div class="col-md-12">
              <!-- <input 
                type="number" 
                id="txtDobavljacCena" 
                name="txtDobavljacCena" 
                formControlName="DobavljacCena"
                class="form-control text-right"
                placeholder="DOKUMENTSTAVKE.NABAVNACENA.SINGULAR"> -->
                <yt-input
                  [Type]="'text'"
                  [Label]="'DOKUMENTSTAVKE.NABAVNACENA.SINGULAR'"
                  formControlName="DobavljacCena">
                </yt-input>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <!-- <div class="col-md-3" *ngIf="isVisible('txtNabavnaCena')"> -->
          <div class="form-group row">
            <!-- <label for="txtUlazniRabatProcenat" class="control-label col-md-6">Ulazni rabat %</label> -->
            <div class="col-md-12">
              <!-- <input 
                  type="number" 
                  id="txtUlazniRabatProcenat" 
                  name="txtUlazniRabatProcenat" 
                  class="form-control text-right"
                  formControlName="UlazniRabatProcenat"
                  placeholder="DOKUMENTSTAVKE.ULAZNIRABATPROCEANT.SINGULAR"> -->
                <yt-input
                  [Type]="'text'"
                  [Label]="'DOKUMENTSTAVKE.ULAZNIRABATPROCENAT.SINGULAR'"
                  formControlName="UlazniRabatProcenat">
                </yt-input>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <!-- <div class="col-md-3" *ngIf="isVisible('txtNabavnaCena')"> -->
          <div class="form-group row">
            <!-- <label for="txtCena" class="control-label col-md-6">Cena:</label> -->
            <div ngClass="col-md-12">
              <!-- <input class="form-control text-right" 
                formControlName="NabavnaCena"
                placeholder="DOKUMENTSTAVKE.NABAVNACENA.SINGULAR"> -->
                <yt-input
                  [Type]="'text'"
                  [Label]="'DOKUMENTSTAVKE.NABAVNACENA.SINGULAR'"
                  formControlName="NabavnaCena">
                </yt-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- <div class="col-md-6">
        </div> -->
        <div class="col-md-12">
          <div class="btn-group float-right">
            <!-- <button
              type="button"
              (click)="SaveMaster(false)" 
              class="btn btn-primary" 
              [disabled]="!baseFormGroup.valid">
                <span translate="SAVE.ACTION">Snimi</span>
            </button>
            <button type="button"  (click)="Cancel()" class="btn">Odustani</button> -->
          </div>
        </div>
      </div>
    <!-- </div> -->
  </form>
</div>